import CatalogSorting from "./CatalogSorting";

export default CatalogSorting;
